import { Injectable } from '@angular/core';
import { IComponentSection } from '../interfaces/component-section';
import { IBrandInfo } from '../interfaces/brand/brand-info';
import { ComponentItem } from '../classes/component-item';
import { HeaderSectionDirective } from '../directives/header-section.directive';
import { FooterSectionDirective } from '../directives/footer-section.directive';
import { BodySectionDirective } from '../directives/body-section.directive';
import { BrandHeaderComponent } from '../components/header-sections/brand-header/brand-header.component';
import { BrandHeaderWithLocaleComponent } from '../components/header-sections/brand-header-with-locale/brand-header-with-locale.component';
import { BrandHeaderImageOnlyComponent } from '../components/header-sections/brand-header-image-only/brand-header-image-only.component';
import { BrandFooterComponent } from '../components/footer-sections/brand-footer/brand-footer.component';
import { BrandFooterContactInfoComponent } from '../components/footer-sections/brand-footer-contact-info/brand-footer-contact-info.component';
import { BrandFooterDisclaimerComponent } from '../components/footer-sections/brand-footer-disclaimer/brand-footer-disclaimer.component';
import { AppleRecoveryComponent } from '../components/body-sections/apple-recovery/apple-recovery.component';
import { NonmobilePageStandardComponent } from '../components/body-sections/nonmobile-page-standard/nonmobile-page-standard.component';
import { NonmobilePageEnhancedComponent } from '../components/body-sections/nonmobile-page-enhanced/nonmobile-page-enhanced.component';
import { SmartLinkStandardComponent } from '../components/body-sections/smart-link-standard/smart-link-standard.component';
import { SmartLinkEnhancedComponent } from '../components/body-sections/smart-link-enhanced/smart-link-enhanced.component';
import { SubaccountsAccordionComponent } from '../components/body-sections/subaccounts-accordion/subaccounts-accordion.component';
import { SubaccountsCardDeckComponent } from '../components/body-sections/subaccounts-card-deck/subaccounts-card-deck.component';
import { NotificationLogGridComponent } from '../components/body-sections/notification-log-grid/notification-log-grid.component';
import { NotificationLogCardDeckComponent } from '../components/body-sections/notification-log-card-deck/notification-log-card-deck.component';
import { XtrViewItemsComponent } from '../components/body-sections/xtr-view-items/xtr-view-items.component';
import { EnrollmentVerificationComponent } from '../components/body-sections/enrollment-verification/enrollment-verification.component';
import { MessagePageComponent } from '../components/body-sections/message-page/message-page.component';

@Injectable({
  providedIn: 'root'
})
export class ComponentSectionFactoryService {

  constructor() { }

  public getComponentSection(sectionTypeName: string, data: any): ComponentItem {
    let componentItem!: ComponentItem;
    let componentSectionName = this.findComponentSectionName(sectionTypeName, data);
    switch(componentSectionName) {
      case "aw-recov":
        componentItem = new ComponentItem(AppleRecoveryComponent, data);
        break;
      case "ev-page":
        componentItem = new ComponentItem (EnrollmentVerificationComponent, data);
        break;
      case "footer":
        componentItem = new ComponentItem(BrandFooterComponent, data);
        break;
      case "footer-contact-info":
        componentItem = new ComponentItem(BrandFooterContactInfoComponent, data);
        break;
      case "footer-disclaimer":
        componentItem = new ComponentItem(BrandFooterDisclaimerComponent, data);
        break;
      case "header":
        componentItem = new ComponentItem(BrandHeaderComponent, data);
        break;
      case "header-image-only":
        componentItem = new ComponentItem(BrandHeaderImageOnlyComponent, data);
        break;
      case "header-with-locale":
        componentItem = new ComponentItem(BrandHeaderWithLocaleComponent, data);
        break;
      case "msg-page":
        componentItem = new ComponentItem (MessagePageComponent, data);
        break;
      case "nonmobile":
        componentItem = new ComponentItem(NonmobilePageStandardComponent, data);
        break;
      case "nonmobile-enhanced":
        componentItem = new ComponentItem(NonmobilePageEnhancedComponent, data);
        break;
      case "notif-log-grid":
        componentItem = new ComponentItem(NotificationLogGridComponent, data);
        break;
      case "notif-log-card-deck":
        componentItem = new ComponentItem(NotificationLogCardDeckComponent, data);
        break;
      case "smart-link":
        componentItem = new ComponentItem(SmartLinkStandardComponent, data);
        break;
      case "smart-link-enhanced":
        componentItem = new ComponentItem(SmartLinkEnhancedComponent, data);
        break;
      case "subaccounts-accordion":
        componentItem = new ComponentItem(SubaccountsAccordionComponent, data);
        break;
      case "subaccounts-card-deck":
        componentItem = new ComponentItem(SubaccountsCardDeckComponent, data);
        break;
      case "xtr-view-items":
        componentItem = new ComponentItem(XtrViewItemsComponent, data);
        break;
      }
    return componentItem;
  }

  private findComponentSectionName(sectionTypeName: string, brandInfo: IBrandInfo): string {
    // console.log('findComponentSectionName - sectionTypeName', sectionTypeName);
    let componentSectionName!: any;
    const configProperties = new Map(Object.entries(brandInfo.configProperties));
    // console.log('findComponentSectionName - configProperties', configProperties);
    if (configProperties) {
      if (configProperties.has(sectionTypeName)) {
        componentSectionName = configProperties.get(sectionTypeName) || '';
      }
    }
    // console.log('findComponentSectionName - componentSectionName', componentSectionName);

    // Use the default section types in case it is not specified
    if (!componentSectionName) {
      switch (sectionTypeName) {
        case 'WAL_PAGES_APPLE_RECOVERY_SECTION_TYPE':
          componentSectionName = "aw-recov";
          break;
        case 'WAL_PAGES_EV_SECTION_TYPE':
          componentSectionName = "ev-page";
          break;
        case 'WAL_PAGES_FOOTER_SECTION_TYPE':
          componentSectionName = "footer";
          break;
        case 'WAL_PAGES_HEADER_SECTION_TYPE':
          componentSectionName = "header";
          break;
        case 'WAL_PAGES_MSG_SECTION_TYPE':
          componentSectionName = "msg-page";
          break;
        case 'WAL_PAGES_NONMOBILE_SECTION_TYPE':
          componentSectionName = "nonmobile";
          break;
        case 'WAL_PAGES_NOTIF_LOG_SECTION_TYPE':
          componentSectionName = "notif-log-card-deck";
          break;
        case 'WAL_PAGES_SMART_LINK_SECTION_TYPE':
          componentSectionName = "smart-link";
          break;
        case 'WAL_PAGES_SUB_ACCOUNTS_SECTION_TYPE':
          componentSectionName = "subaccounts-accordion";
          break;
        case 'WAL_PAGES_VIEW_ITEMS_SECTION_TYPE':
          componentSectionName = "xtr-view-items";
          break;
  
      }
    }
    return componentSectionName;
  }

  public loadHeaderSection(brandInfo: IBrandInfo, headerComponentSection: HeaderSectionDirective, additionalParams?: Map<string,any>) {
    const pageHeader = this.getComponentSection("WAL_PAGES_HEADER_SECTION_TYPE", brandInfo);
    const viewContainerRef = headerComponentSection.viewContainerRef;
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent<IComponentSection>(pageHeader.component);
    componentRef.instance.data = pageHeader.data;
    if (additionalParams) {
      componentRef.instance.additionalParams = additionalParams;
    }
  } 

  public loadBodySection(brandInfo: IBrandInfo, bodySectionType: string, bodyComponentSection: BodySectionDirective) {
    const pageBody = this.getComponentSection(bodySectionType, brandInfo);
    const viewContainerRef = bodyComponentSection.viewContainerRef;
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent<IComponentSection>(pageBody.component);
    componentRef.instance.data = pageBody.data;
  }    

  public loadFooterSection(brandInfo: IBrandInfo, footerComponentSection: FooterSectionDirective) {
    const pageFooter = this.getComponentSection("WAL_PAGES_FOOTER_SECTION_TYPE", brandInfo);
    const viewContainerRef = footerComponentSection.viewContainerRef;
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent<IComponentSection>(pageFooter.component);
    componentRef.instance.data = pageFooter.data;
  }    
}
